
import _ from "lodash";
import rest from "@/rest";
import { Component, Vue } from "vue-property-decorator";
import { LogEntry } from "@/interfaces/LogEntry";

@Component
export default class Logging extends Vue {
  searchValue = "";
  logs: LogEntry[] = [];

  // $refs!: {};

  headers = [
    { text: "Zeit",value: "time",sortable: true },
    { text: "Anwender", value: "user",sortable: true },
    { text: "Meldung", align: "left", value: "message", sortable: true },
    { text: "Details", align: "left", value: "messageDetails",sortable: true },
    { text: "Context", value: "context",sortable: true },
    { text: "Aktion", value: "action", sortable: false },
    { text: "Status", value: "status", sortable: true }
  ];

  mounted() {
    this.updateLogging();
  }

  async onSearchChanged() {
    await this.updateLogging();
  }

  async updateLogging() {
    // this.logs = await rest.url("admin/getLogEntries").post();
    this.logs = await rest.url("admin/getLogEntries").query({ search: this.searchValue ?? "" }).get();
  }
}
